import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private inFlightCount = signal(0);

  /** Reactive signal indicating whether there are in-flight network requests */
  readonly isLoading = computed(() => this.inFlightCount() > 0);

  start(): void {
    this.inFlightCount.update(c => c + 1);
  }

  stop(): void {
    this.inFlightCount.update(c => Math.max(0, c - 1));
  }

  reset(): void {
    this.inFlightCount.set(0);
  }
}
